import React, { useState } from "react";
import axios from "axios";
import { setUserSession, getWeekNumber, PHP_BACK } from "../../utils/Common";
import './login.css';
import MyLoader from "../sharecomponents/MyLoader";
import BlurModal from "../sharecomponents/blurModal";
import girasol from '../../assets/girasol.jpg';
import logo from '../../assets/logo.png';
import VainillaDialog from "../sharecomponents/vanilladialog";

const useFormInput = (initialValue) => {
   const [value, setValue] = useState(initialValue);

   const handleChange = (e) => {
      setValue(e.target.value);
   };

   return {
      value,
      onChange: handleChange,
   };
};

function Login(props) {
   const username = useFormInput("");
   const password = useFormInput("");
   const [loader, setLoader] = useState(false);
   const [showAlert, SetshowAlert] = useState(false);
   const [dialog, setdialog] = useState({});

   // const [error, setError] = useState(null);
   // const [loading, setLoading] = useState(false);

   const imgStyle = {
      backgroundImage: "url('" + girasol + "')",
      backgroundSize: 'cover',
      backgroundPosition: ' center center',
      backgroundRepeat: 'no-repeat',
      overflow: "auto"
      // opacity: '.95'
   };

   const handleLogin = () => {
      // setError(null)
      // setLoading(true); 
      // -- Login en API /user/login
      setLoader(true);
      axios
         .post(PHP_BACK + "auth/login", { login: username.value, pass: password.value })
         .then((response) => {
            setLoader(false);
            if (response.data.success) {
               let noWeek = getWeekNumber(new Date()); // -- el numero de semana que nos encontramos
               setUserSession({ ...response.data.user, noWeek });
               props.history.push("/");
            } else {
               SetshowAlert(true);
            }
         })
         .catch((error) => {
            setLoader(false);
            console.error(error);
            // setError('Intente de nuevo porfavor');
         });
   };



   return (
      <div className="vw-100 vh-100 m-0 p-0 contenedor dosis" style={imgStyle}>
         <div className='row justify-content-evenly w-100 p-0 m-0'>
            <div className='shadow-multi pxw-300 bg-white4 blur-xxl round-m p-3' style={{ width: "40%", minWidth: "350px", maxWidth: "450px" }}>
               <div className='row justify-content-evenly w-100 p-0 m-0'>
                  <img src={logo} alt="Logo" className="" style={{ width: "70%", minWidth: "200px", maxWidth: "400px" }} />
                  <form className='col-lg-12 m-0 p-1 pt-3'>
                     <div className='w-100'>
                        <div className='row justify-content-center'>
                           <label className='text-bold h4 mb-1' style={{ width: "100%", minWidth: "250px", maxWidth: "350px", color: '#521c3e' }}>Usuario</label>
                           <input type='text'
                              className='form-control mt-0 border shadow'
                              placeholder='Ingrese su nombre de usuario'
                              id="username"
                              onKeyDown={(event) => { if (event.keyCode === 13) { handleLogin(); } }}
                              {...username}
                              style={{ width: "100%", minWidth: "250px", maxWidth: "350px" }} />
                        </div>
                     </div>

                     <div className='w-100 mt-4'>
                        <div className='row justify-content-center'>
                           <label className='text-bold h4 mb-1'
                              style={{ width: "100%", minWidth: "250px", maxWidth: "350px", color: '#521c3e' }}>
                              Contraseña
                           </label>
                           <input type='password'
                              className='form-control mt-0 border shadow'
                              placeholder='Ingrese su contraseña'
                              id="pass"
                              {...password}
                              onKeyDown={(event) => { if (event.keyCode === 13) { handleLogin(); } }}
                              style={{ width: "100%", minWidth: "250px", maxWidth: "350px" }} />
                        </div>
                     </div>

                     <div className='col-lg-12 mt-4 mb-4 p-0 text-center'>
                        <button
                           className="ps-5 pe-5 h3 shadow hover:bg-red-800 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 round-xl scale-025"
                           type="button"
                           style={{ backgroundColor: '#521c3e' }}
                           onClick={handleLogin}
                        >
                           Iniciar sesión
                        </button>
                     </div>
                  </form>
               </div>
            </div>
            {/*<div className="shadow-multi bw-300  p-3 border rounded-lg opacity-100 pb-5">
               <img src={logo} alt="Logo" className="pxw-200" />
               <form className="w-full mt-5">
                  <div className="md:flex md:items-center mb-6">
                     <div className="md:w-1/3">
                        <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" style={{ color: '#521c3e' }}>
                           Usuario:
                        </label>
                     </div>
                     <div className="md:w-2/3">
                        <input
                           className="bg-gray-100 appearance-none border-2 border-gray-300 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-red-800"
                           id="username"
                           type="text"
                           onKeyDown={(event) => { if (event.keyCode === 13) { handleLogin(); } }}
                           {...username}
                           placeholder="Usuario" />
                     </div>
                  </div>
                  <div className="md:flex md:items-center mb-6">
                     <div className="md:w-1/3">
                        <label className="block text-gray-700 font-bold md:text-right mb-1 md:mb-0 pr-4" style={{ color: '#521c3e' }}>
                           Contraseña:
                        </label>
                     </div>
                     <div className="md:w-2/3">
                        <input
                           className="bg-gray-100 appearance-none border-2 border-gray-300 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-red-800"
                           id="pass"
                           type="password"
                           {...password}
                           placeholder="Escriba su contraseña"
                           onKeyDown={(event) => { if (event.keyCode === 13) { handleLogin(); } }}
                        ></input>
                     </div>
                  </div>
                  <div className="md:flex md:items-center">
                     <div className="md:w-1/3"></div>
                     <div className="md:w-2/3">
                        <button
                           className="shadow hover:bg-red-800 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                           type="button"
                           style={{ backgroundColor: '#521c3e' }}
                           onClick={handleLogin}
                        >
                           Iniciar Sesión
                        </button>
                     </div>
                  </div>
               </form>
            </div>*/}
            {loader && <MyLoader />}
            {showAlert && <BlurModal show="true" title="Ocurrió un error" message="El usuario y/o contraseña ingresados son incorrectos" hide={SetshowAlert} />}
         </div>

      </div>
   );
}

export default Login;
